export class AICoachReviewError extends Error {
	constructor(
		message: string,
		public readonly status?: number
	) {
		super(message);
		this.name = "AICoachReviewError";
	}
}

export class InsufficientBalanceError extends AICoachReviewError {
	constructor() {
		super("Insufficient balance to generate AI coach review", 409);
		this.name = "InsufficientBalanceError";
	}
}
